import '../App.css'
import  './events.css';
import iconSecton from '../img/icon-section.png';
import EventsList from './eventsList';
import { useNavigate } from 'react-router-dom';


function Interviews() {
  const navigate = useNavigate();

  return (
    <div className="events">
      <section id="interviews">
        <img src={iconSecton} alt="icon-section" className="icon-section" />
        <h1>Interview</h1>
      </section>
      <div className="events-intro">
        <h2></h2>
        <p></p>
      </div>
      <EventsList category="interview" />
      <button
        className="button-eventsExplore"
        onClick={() => navigate('/interviews')}
      >
        <h3>全てのインタビューを見る</h3>
      </button>
    </div>
  );
}

export default Interviews;
